//-- copyright
// OpenProject is an open source project management software.
// Copyright (C) the OpenProject GmbH
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
//
// See COPYRIGHT and LICENSE files for more details.
//++

import { Controller } from '@hotwired/stimulus';
import { useDebounce, useMutation } from 'stimulus-use';

/**
 * A simple controller to allow <select> elements automatically grow to fit
 * their options.
 *
 * Use `data-select-autosize-size-limit-value` to specify a size limit.
 */
export default class SelectAutosizeController extends Controller<HTMLSelectElement> {
  static values = {
    sizeLimit: { type: Number, default: 10 }
  };

  static debounces = ['updateSize'];

  declare sizeLimitValue:number;

  connect() {
    useMutation(this, { childList: true });
    useDebounce(this, { wait: 100 });

    this.updateSize();
  }

  mutate(mutations:MutationRecord[]) {
    if (mutations.some(m => m.type === 'childList')) {
      this.updateSize();
    }
  }

  private updateSize() {
    this.element.size = Math.min(this.element.options.length, this.sizeLimitValue);
  }
}
